import {ajax_get, ajax_post} from "./index";

export const selectmenus = (data) => ajax_get('/museummenu', data);

export const getuploadfileparams = (data) => ajax_get('/annexupprepare',data)

export const removepic = (data) => ajax_get('/annexdelete',data)

export const selectPicDetail = (data) => ajax_get('/annexfileinfo',data)

